import { useMemo, useState } from "react";
import { useDiagramData } from "../useDiagramData";
import {
  ANALYSIS_TABLE_TYPE_OPTIONS,
  DEFAULT_ANALYSIS_TABLE_TYPE,
} from "../analysisConstants";
import StepBarDiagram from "./StepBarDiagram";
import DailyCasesLineChart from "./DailyCasesLineChart";

function getTableTypeLabel(value) {
  return (
    ANALYSIS_TABLE_TYPE_OPTIONS.find((option) => option.value === value)?.label ||
    value
  );
}

export default function RemediationDiagramCard({
  searchSpace,
  remediationType,
}) {
  const [selectedTableType, setSelectedTableType] = useState(
    DEFAULT_ANALYSIS_TABLE_TYPE
  );

  const { loading, status, diagram } = useDiagramData(
    searchSpace,
    remediationType,
    selectedTableType
  );

  const subtitle = useMemo(() => {
    return getTableTypeLabel(selectedTableType);
  }, [selectedTableType]);

  const renderDiagram = () => {
    if (!diagram?.data?.length) {
      return (
        <div className="analysis-diagram-empty">
          No data available for this diagram.
        </div>
      );
    }

    switch (diagram.chartKind) {
      case "step-bar-total":
        return <StepBarDiagram data={diagram.data} variant="total" />;

      case "step-bar-percent":
        return <StepBarDiagram data={diagram.data} variant="percent" />;

      case "step-bar-days":
        return <StepBarDiagram data={diagram.data} variant="mttr" />;

      case "daily-line":
        return <DailyCasesLineChart data={diagram.data} />;

      default:
        return (
          <div className="analysis-diagram-empty">
            This diagram type is not yet supported in the frontend.
          </div>
        );
    }
  };

  return (
    <div className="analysis-diagram-card">
      <div className="analysis-diagram-card-header">
        <div className="analysis-diagram-card-heading">
          <div className="analysis-diagram-card-title">{remediationType}</div>
          <div className="analysis-diagram-card-subtitle">{subtitle}</div>
        </div>

        <label className="analysis-diagram-select-wrap">
          <span className="analysis-diagram-select-label">Diagram</span>
          <select
            className="analysis-diagram-select"
            value={selectedTableType}
            onChange={(e) => setSelectedTableType(e.target.value)}
          >
            {ANALYSIS_TABLE_TYPE_OPTIONS.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </label>
      </div>

      {status && <div className="analysis-diagram-status">{status}</div>}

      {loading ? (
        <div className="analysis-diagram-loading">Loading diagram...</div>
      ) : (
        renderDiagram()
      )}
    </div>
  );
}